// Mock earned/backlinks data
export const mockEarnedData = {
  total_backlinks: 2341,
  referring_domains: 345,
  new_links_this_month: 123,
  lost_links_this_month: 8,
  top_sources: [
    {
      domain: 'techblog.com',
      links: 45,
      anchor_text: 'trading platform'
    },
    {
      domain: 'financenews.io',
      links: 38,
      anchor_text: 'market analysis tool'
    },
    {
      domain: 'investorguide.com',
      links: 32,
      anchor_text: 'trading software'
    }
  ],
  mentions: {
    brand_mentions: 567,
    unlinked_mentions: 234
  }
};
